import { Hash } from '@webreact/webreactor/dist/tools/async-hash'

const hash = new Hash()

export default () => ({
	initialized: false,
	visible: false,
	hash: '',
	hashableContent: '',

	init() {
		this.initialized = true
		this.hash = hash.getHash('global-popup')

		this.$nextTick(() => {
			this.checkHashes()
		})
	},

	async checkHashes() {
		this.hashableContent = this.$refs.content.textContent.trim()

		if (!this.hash) {
			this.visible = true
		}

		if (!(await hash.areHashesEqual('global-popup', this.hashableContent))) {
			this.visible = true
		}
	},

	closeModal() {
		this.visible = false
		this.registerClick()
	},

	registerClick() {
		// Stored for a month
		hash.storeHash('global-popup', this.hashableContent, 2592000)
	},
})
